import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const PublicRoute = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const location = useLocation();

  if (isAuthenticated) {
    const from = location.state?.from?.pathname || "/landlords/portfolio-performance";
    return <Navigate to={from} replace />;  
}

  return <Outlet />;
};

export default PublicRoute;
